<ng-container *ngIf="state$ | async as state">
    <ng-container [ngSwitch]="state.status">
        <ng-container *ngSwitchCase="'OK'">

            <h2 mat-dialog-title class="pv-dialog-title">
                <mat-icon class="material-symbols-outlined">table_view</mat-icon>
                <span class="pv-dialog-title-text">Edit Table Component</span>
                <button mat-icon-button class="pv-dialog-close" (click)="cancel()" matTooltip="Close" aria-label="Close dialog">
                    <mat-icon>close</mat-icon>
                </button>
            </h2>

            <mat-dialog-content class="pv-dialog-body">
                <form id="report_table_component_form"
                    [formGroup]="formGroup"
                    (ngSubmit)="attempt()"
                    autocomplete="off"
                >

                    <div class="field-block">
                        <label class="field-label">Cell alignment</label>
                        <div class="table-toolbar">
                            <!-- HORIZONTAL ALIGNMENT -->
                            <button class="config-button" type="button" [class.active]="getOrientation('horizontal', 'left')" mat-icon-button (click)="setHorizontial('left'); $event.preventDefault();" matTooltip="Left Align">
                                <mat-icon class="material-symbols-outlined">format_align_left</mat-icon>
                            </button>
                            <button class="config-button" type="button" [class.active]="getOrientation('horizontal', 'center')" mat-icon-button (click)="setHorizontial('center'); $event.preventDefault();" matTooltip="Center Align">
                                <mat-icon class="material-symbols-outlined">format_align_center</mat-icon>
                            </button>
                            <button class="config-button" type="button" [class.active]="getOrientation('horizontal', 'right')" mat-icon-button (click)="setHorizontial('right'); $event.preventDefault();" matTooltip="Right Align">
                                <mat-icon class="material-symbols-outlined">format_align_right</mat-icon>
                            </button>

                            <!-- VERTICAL ALIGNMENT -->
                            <button class="config-button" type="button" [class.active]="getOrientation('vertical', 'top')" mat-icon-button (click)="setVertical('top'); $event.preventDefault();" matTooltip="Top Align">
                                <mat-icon class="material-symbols-outlined">vertical_align_top</mat-icon>
                            </button>
                            <button class="config-button" type="button" [class.active]="getOrientation('vertical', 'middle')" mat-icon-button (click)="setVertical('middle'); $event.preventDefault();" matTooltip="Middle Align">
                                <mat-icon class="material-symbols-outlined">vertical_align_center</mat-icon>
                            </button>
                            <button class="config-button" type="button" [class.active]="getOrientation('vertical', 'bottom')" mat-icon-button (click)="setVertical('bottom'); $event.preventDefault();" matTooltip="Bottom Align">
                                <mat-icon class="material-symbols-outlined">vertical_align_bottom</mat-icon>
                            </button>
                        </div>
                    </div>

                    <div class="field-block">
                        <mat-slide-toggle color="primary" formControlName="showBorders">Show borders</mat-slide-toggle>
                    </div>

                    <div class="two-col">
                        <div class="field-block">
                            <label class="field-label">Table label</label>
                            <mat-form-field appearance="outline" class="full-width">
                                <input matInput type="text" formControlName="label" autocomplete="off">
                                <mat-error>Required (max 40 characters)</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="field-block">
                            <label class="field-label">Table data type</label>
                            <div class="chip-row">
                                <button type="button" class="opt-chip" [class.active]="formGroup.value.type === 'STATIC'" [attr.aria-pressed]="formGroup.value.type === 'STATIC'" (click)="formGroup.get('type').setValue('STATIC'); $event.preventDefault();">
                                    <span>Static</span>
                                </button>
                                <button type="button" class="opt-chip" [class.active]="formGroup.value.type === 'DYNAMIC'" [attr.aria-pressed]="formGroup.value.type === 'DYNAMIC'" (click)="formGroup.get('type').setValue('DYNAMIC'); $event.preventDefault();">
                                    <span>Dynamic</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <ng-container *ngIf="formGroup.value.type == 'DYNAMIC'">
                        <div class="field-block">
                            <label class="field-label">Conversion system</label>
                            <div class="chip-row">
                                <button type="button" class="opt-chip" [class.active]="formGroup.get('system')?.value === 'METRIC'" [attr.aria-pressed]="formGroup.get('system')?.value === 'METRIC'" (click)="formGroup.get('system').setValue('METRIC'); $event.preventDefault();">
                                    <span>Metric</span>
                                </button>
                                <button type="button" class="opt-chip" [class.active]="formGroup.get('system')?.value === 'IMPERIAL'" [attr.aria-pressed]="formGroup.get('system')?.value === 'IMPERIAL'" (click)="formGroup.get('system').setValue('IMPERIAL'); $event.preventDefault();">
                                    <span>Imperial</span>
                                </button>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container [ngSwitch]="formGroup.value.type">

                        <!-- STATIC TABLE FORM START -->
                        <ng-container *ngSwitchCase="'STATIC'">
                            <div class="table-toolbar">
                                <button type="button" mat-raised-button color="primary" (click)="removeRow();$event.preventDefault();">Remove Row {{ lastGroupIndex + 1 }}</button>
                                <button type="button" mat-raised-button color="primary" (click)="removeColumn();$event.preventDefault();">Remove Column {{ lastEntryIndex + 1 }}</button>
                                <button class="config-button no-border" type="button" mat-icon-button matTooltip="Removes the last active row/column. Default is the last row and column.">
                                    <mat-icon class="material-symbols-outlined">help</mat-icon>
                                </button>
                            </div>

                            <div class="table-container">
                                <table class="report-table">
                                    <ng-container formArrayName="groups">
                                        <tr *ngFor="let group of groupsFormArray.controls; let groupIndex = index"
                                            [formGroupName]="groupIndex"
                                            class="row">
                                            <td class="first-cell col">{{ groupIndex + 1}}</td>

                                            <ng-container formArrayName="entries">
                                                <td *ngFor="let entry of getEntriesFormArray(groupIndex).controls; let entryIndex = index"
                                                    [formGroupName]="entryIndex"
                                                    class="cell"
                                                    [class.top]="currentVertical == 'top'"
                                                    [class.middle]="currentVertical == 'middle'"
                                                    [class.bottom]="currentVertical == 'middle'"
                                                    [class.left]="currentHorizontal == 'left'"
                                                    [class.center]="currentHorizontal == 'center'"
                                                    [class.right]="currentHorizontal == 'right'"
                                                    [class.first-cell]="groupIndex == 0">

                                                    <input type="text"
                                                        formControlName="content"
                                                        (click)="stopEditing(groupIndex, entryIndex)">
                                                </td>
                                            </ng-container>
                                        </tr>
                                    </ng-container>
                                </table>

                                <!-- ADD COLUMN BUTTON -->
                                <button type="button" mat-mini-fab color="primary" class="add-column-btn" (click)="addTableEntry()" matTooltip="Add Column">
                                    <mat-icon>add</mat-icon>
                                </button>

                                <!-- ADD ROW BUTTON -->
                                <button type="button" mat-mini-fab color="primary" class="add-row-btn" (click)="addTableGroup()" matTooltip="Add Row">
                                    <mat-icon>add</mat-icon>
                                </button>
                            </div>
                        </ng-container>
                        <!-- STATIC TABLE FORM END -->

                        <!-- DYNAMIC TABLE FORM START -->
                        <ng-container *ngSwitchCase="'DYNAMIC'">
                            <div class="field-block">
                                <label class="field-label">Context</label>
                                <div class="chip-row">
                                    <button type="button" *ngFor="let option of tableContextOptions"
                                            class="opt-chip"
                                            [class.active]="formGroup.get('context')?.value === option.value"
                                            [attr.aria-pressed]="formGroup.get('context')?.value === option.value"
                                            (click)="formGroup.get('context').setValue(option.value); $event.preventDefault();">
                                        <span>{{ option.label }}</span>
                                    </button>
                                </div>
                            </div>

                            <div class="field-block">
                                <label class="field-label">Table data</label>

                                <!-- PROPERTIES -->
                                <pv-filter-search
                                    [options]="state.properties | filterByCategoryContext: formGroup.get('context')?.value"
                                    [formControl]="propertiesControl"
                                    dataLabel="Properties"
                                    searchLabel="label"
                                    [multiple]="true"
                                >
                                </pv-filter-search>

                                <!-- CALCULATIONS -->
                                <pv-filter-search
                                    [options]="state.calculations"
                                    [formControl]="calculationsControl"
                                    dataLabel="Calculations"
                                    searchLabel="label"
                                    [multiple]="true"
                                >
                                </pv-filter-search>

                                <!-- CLASSIFICATIONS -->
                                <pv-filter-search
                                    [options]="state.classifications"
                                    [formControl]="classificationsControl"
                                    dataLabel="Classifications"
                                    searchLabel="label"
                                    [multiple]="true"
                                >
                                </pv-filter-search>

                                <!-- CHARS -->
                                <pv-filter-search
                                    [options]="state.characteristics"
                                    [formControl]="charsControl"
                                    dataLabel="Characteristics"
                                    searchLabel="label"
                                    [multiple]="true"
                                >
                                </pv-filter-search>

                                <!-- INDEXES -->
                                <pv-filter-search
                                    [options]="state.indexes"
                                    [formControl]="indexesControl"
                                    dataLabel="Indexes"
                                    searchLabel="label"
                                    [multiple]="true"
                                >
                                </pv-filter-search>

                                <!-- MEASURES -->
                                <pv-filter-search
                                    [options]="state.measures"
                                    [formControl]="measuresControl"
                                    dataLabel="Measurements"
                                    searchLabel="label"
                                    [multiple]="true"
                                >
                                </pv-filter-search>
                            </div>

                            <div class="field-block">
                                <label class="field-label">Data points
                                    <span class="field-label-hint">({{dataPointControls.length || '0'}}) — drag to reorder</span>
                                </label>
                                <pv-dp-reorder-list
                                    [formArray]="dataPointsFormArray"
                                    [itemTemplate]="dpItemTemplate"
                                    (remove)="removeDataPoint($event, dataPointControls[$event].value.type)"
                                ></pv-dp-reorder-list>
                                <ng-template #dpItemTemplate let-dataPoint>
                                    <span class="dp-name">{{ dataPoint.value.id | describeTableDataPoint : dataPoint.value.type }}</span>
                                </ng-template>
                            </div>

                        </ng-container>
                        <!-- DYNAMIC TABLE FORM END -->

                    </ng-container>
                </form>
            </mat-dialog-content>

            <mat-dialog-actions align="end" class="pv-dialog-footer">
                <button type="button" mat-stroked-button (click)="cancel()">Cancel</button>
                <button type="button" mat-flat-button color="primary" (click)="attempt()">
                    <mat-icon>check</mat-icon>
                    Apply
                </button>
            </mat-dialog-actions>

        </ng-container>

        <ng-container *ngSwitchCase="'LOADING'">
            <div class="pv-dialog-loading">
                <pv-spinner message="Loading options…" fill="white"></pv-spinner>
            </div>
        </ng-container>

    </ng-container>
</ng-container>
